import { render } from "./richiediPagamentoModal.vue?vue&type=template&id=86477d6a&scoped=true&ts=true"
import script from "./richiediPagamentoModal.vue?vue&type=script&lang=ts"
export * from "./richiediPagamentoModal.vue?vue&type=script&lang=ts"

import "./richiediPagamentoModal.vue?vue&type=style&index=0&id=86477d6a&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86477d6a"]])

export default __exports__